// extracted by mini-css-extract-plugin
module.exports = {"root":"HomePage_root__1F6iG","content":"HomePage_content__RUBai"};